import { VendorMetadata } from "../type";

import { Vendor } from "./data";

export const Bitwarden: VendorMetadata = Object.freeze({
  id: Vendor.bitwarden,
  name: "Bitwarden",
});
